<mat-card class="safe-zones">
  <ngrx-busy #szBusy>

    <app-headline>
      <h1 app-headline-title
      color="primary">Safe zones</h1>
    </app-headline>
    <div class="safe-zones-wrapper">
      @for (safeZone of safeZones$ | async; track safeZone) {
        <app-safe-zone-card
          [safeZone]="safeZone"
        class="safe-zone"></app-safe-zone-card>
      } @empty {
        <p class="empty-state">No safe zones.</p>
      }
    </div>
  </ngrx-busy>
</mat-card>

<mat-card class="feeds">
  <ngrx-busy #feedBusy>
    <app-headline>
      <h1 app-headline-title
      color="primary">Feed</h1>
    </app-headline>

    @if (feeds$ | async; as feeds) {
      @if (customer$ | async; as customer) {
        <cdk-virtual-scroll-viewport itemSize="80" tabindex="0" aria-label="Customer activity feed">
          <app-feed-card *cdkVirtualFor="let feed of feeds"
            [feed]="feed"
            [tz]="customer.time_zone"
          class="feed"></app-feed-card>
        </cdk-virtual-scroll-viewport>
      }
    }
  </ngrx-busy>
</mat-card>

<mat-card class="sessions">
  <ngrx-busy #sessionsBusy>
    <app-headline>
      <h1 app-headline-title
      color="primary">Sessions</h1>
    </app-headline>

    <div class="sessions-wrapper">
      @for (session of sessions$ | async; track session) {
        <app-session-card
          [session]="session"
        class="session"></app-session-card>
      } @empty {
        <p class="empty-state">No active sessions.</p>
      }
    </div>
  </ngrx-busy>
</mat-card>

<mat-card class="notification-settings">
  <app-headline>
    <h1 app-headline-title
    color="primary">Notification settings</h1>
  </app-headline>

  @if (notificationSettings$ | async; as settings) {
    <mat-tab-group mat-align-tabs="center"
      class="notifications-tabs">
      <mat-tab label="Push">
        <div class="notification-target">
          @for (set of settings.push; track set) {
            <div
              class="notification-group">
              {{set.name}}
              @for (item of set.items; track item) {
                <mat-slide-toggle
                  color="primary"
                  labelPosition="before"
                  [checked]="item.enabled"
                  [disabled]="true">
                  {{item.name}}
                </mat-slide-toggle>
              }
            </div>
          }
        </div>
      </mat-tab>
      <mat-tab label="Email">
        <div class="notification-target">
          @for (set of settings.email; track set) {
            <div
              class="notification-group">
              {{set.name}}
              @for (item of set.items; track item) {
                <mat-slide-toggle
                  color="primary"
                  labelPosition="before"
                  [checked]="item.enabled"
                  [disabled]="true">
                  {{item.name}}
                </mat-slide-toggle>
              }
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</mat-card>
